import { useLazyGetTeamPreferenceQuery } from '@app/api/preferences';
import useEffectOnce from '@app/hooks/useEffectOnce';
import useSelector from '@app/hooks/useSelector';
import { getProject, getSession, getTeam } from '@app/selectors';

import TrialOver from './TrialOver';
import TryDesignPlugins from './TryDesignPlugins';

// Allowed plan IDs for this experiment.
// Taken from https://lokalise.atlassian.net/wiki/spaces/GT/pages/2296348673/Explore+design+plugins
const allowedPlanIds = [21, 30, 31, 33, 35, 37, 61, 71, 76, 81, 150, 151, 152, 153, 250, 251, 252, 253];

const ExploreDesignPlugins = () => {
    const { planId, userId } = useSelector(getSession);
    const { id: teamId, role: teamRole } = useSelector(getTeam);
    const { documentProject } = useSelector(getProject);
    const [loadPreference, { data, isLoading, isUninitialized }] = useLazyGetTeamPreferenceQuery();

    const isTeamBillerOrOwner = ['owner', 'biller'].includes(teamRole);
    const isValidPlan = allowedPlanIds.includes(Number(planId));
    const isSoftwareProject = !documentProject;

    const hasPermissions = isTeamBillerOrOwner && isValidPlan && isSoftwareProject;

    useEffectOnce(() => {
        if (isUninitialized && hasPermissions) {
            loadPreference({ teamId, name: 'design_plugins_trial' });
        }
    });

    const isNotInterested = data?.value === 'not_interested';
    const isTrialActivated = data?.value === 'activated' && data?.expired === false;
    const isTrialOver = data?.value === 'activated' && data?.expired;
    const isTrialFinished = data?.value === 'trial_finished';

    if (!hasPermissions || isUninitialized || isLoading || isTrialActivated || isNotInterested || isTrialFinished) {
        return null;
    }

    if (isTrialOver) {
        const createdByUserId = data?.userId.toString();

        if (userId === createdByUserId) {
            return <TrialOver teamId={teamId} />;
        }

        return null;
    }

    return <TryDesignPlugins teamId={teamId} />;
};

export default ExploreDesignPlugins;
